import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { PortalSettingsService } from '../services/portal-settings.service';

@Injectable({
  providedIn: 'root'
})
export class PortalSettingsResolverService implements Resolve<any> {

  constructor(private http: HttpClient, private portalSettings: PortalSettingsService) { }


  resolve(): any {
    if (this.portalSettings.getPortalSettings() == null) {
      return this.http.get('/Account/GetPortalSettings')
        .toPromise()
        .then((response) => {
          this.portalSettings.setPortalSettings(response);
        });
    }
  }
}
